class Routes {

    static readonly landing = '/';
    static readonly home = '/home';
    static readonly error = '/error';

}

export default Routes;
